export default __webpack_public_path__ + "static/media/marketplace-info-hero-2.e095e50e.jpg";